import React, { useState } from 'react'
import './index.scss'
import { observer } from 'mobx-react'
import clsx from 'clsx'

interface ToggleLabelProps {
    mainColor: boolean
    onClick: (isChecked: boolean) => void
    label?: string
    internalLabel?: string
    checked?: boolean
    disabled?: boolean
}

const ToggleLabel = (props: ToggleLabelProps) => {
    const { mainColor, onClick, label, internalLabel, checked, disabled } = props

    const [isChecked, setIsChecked] = useState(checked || false)

    const allCheckedToggle = () => {
        setIsChecked(!isChecked)
        onClick(!isChecked)
    }

    return (
        <div
            className={clsx(
                'toggle-label-component',
                mainColor ? 'main-color-set' : 'second-color-set',
                disabled && 'disabled'
            )}
            onClick={!disabled ? allCheckedToggle : () => {}}
            data-testid="toggle-label-component"
        >
            {label && <span className="toggle-label small">{label}</span>}
            <div className={clsx('toggle-wrapper small', isChecked && 'checked')}>
                {internalLabel && (
                    <span className={clsx('internal-toggle-label small', isChecked && 'checked')}>{internalLabel}</span>
                )}
            </div>
        </div>
    )
}

export default observer(ToggleLabel)
